import {
  Progress,
  Grid,
  GridItem,
  Text,
  createStandaloneToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  AdminChecklistItems,
  AssessmentType,
  SelectionItem,
  GeneralSettingType,
  IAvailableQuestions,
  IButtonState,
  IQuestionResponse,
  IQuestionType,
  WorkType,
  workTypeObject,
} from "../../CommonProps";
import { IValues, JobEstimationDetail } from "../../modals/JobEstimationDetail";
import { Appointment } from "../../modals/Appointment";
import { IBSAdonisService } from "../../Services/IBSAdonisService";
import LoaderCommon from "../../Loader/LoaderCommon";
import { CommonMethodService } from "../../Services/CommonMethodService";
import StepTwo from "./StepTwo";
import StepFour from "./StepFour";
import StepThree from "./StepThree";
import { IBodyshopService } from "../../UserService";
import { Mixpanel } from "../../Services/MixPanel";
import AssessmentDialog from "../assessment-status/assessment-dialog";
import APIService from "../../Services/APIService";
import { IDS } from "../../constants/Ids";
import CarbizAssessmentDialog from "../assessment-status/carbiz-assessment-dialog";
import { ReferralProviderId } from "../../modals/Enums/Common";

const logout = require("../../../src/assets/images/logout.png").default;
const AssessmentId = IDS.ASSESSMENT.MAIN;
const Assessment = () => {
  const repairChoiceQuestion = "How would you describe the extent of damage?";
  const toast = createStandaloneToast();
  const [step, setStep] = useState<number>(1);
  const [stepProgress, setStepProgress] = useState<number>(25);
  const [modalState, setModalState] = useState<number>(1);
  const [questionsArray, setQuestionsArray] = useState<IQuestionResponse[]>([]);
  const [loadBtn, setLoadBtn] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [compassModal, setCompassModal] = useState<boolean>(false);
  const [carbizModal, setCarbizModal] = useState<boolean>(false);
  const [bookingIsLoading, setBookingIsLoading] = useState<boolean>(false);
  const [estimate, setEstimate] = useState<JobEstimationDetail>();
  const [estimateBooking, setEstimateBooking] = useState<Appointment | null>(
    null
  );
  const [selectedAssessment, setselectedAssessment] = useState<
    AssessmentType | string
  >("");

  const [estimateId, setEstimateId] = useState<string>("");

  const [hasArrivalDates, setHasArrivalDates] = useState<boolean>(true);
  const [compassReference, setCompassReference] = useState<string | null>(null);
  const [availableQuestionsArray, setAvailableQuestionsArray] = useState<
    IAvailableQuestions[]
  >([
    {
      state: 1,
      step: 2,
      type: IQuestionType.FAULT,
      title: "Were you at fault?",
      actionState: IButtonState.NONE,
    },
    {
      state: 2,
      step: 2,
      type: IQuestionType.FAULT_DETAILS,
      title: "Do you have the at-fault details?",
      actionState: IButtonState.NONE,
    },
    {
      state: 2,
      step: 2,
      type: IQuestionType.FAULT_INSURANCE,
      title: "Does the at-fault have insurance?",
      actionState: IButtonState.NONE,
    },
  ]);

  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const ibsAdonisService = new IBSAdonisService();
  const commonMethodService = new CommonMethodService();
  const ibodyshop = new IBodyshopService();
  const apiService = new APIService();

  const assessmentOptions = [
    {
      label: AssessmentType.Minor,
      value: WorkType.SMALL,
    },
    {
      label: AssessmentType.Moderate,
      value: WorkType.MEDIUM,
    },
    {
      label: AssessmentType.Major,
      value: WorkType.LARGE,
    },
  ];

  const fetchCurrentPageParams = async () => {
    const currentParams = new URLSearchParams(location.search);
    const formStepParam = currentParams.get("formStep");
    const bookingParam = currentParams.get("step");

    if (!params.id) {
      navigate("/");
    }
    // If the booking flow is complete or a booking inspection exists, the user must navigate to the booking inspection screen. They cannot restart the welcome flow.
    else if (params.id) {
      try {
        const recordExist = await ibsAdonisService.fetchInspectionData(
          `${params.id}`
        );
        if (recordExist) {
          navigate(`/?estimateid=${params.id}&step=booking-inspection`);
        }
      } catch (error) {
        // Handle API call error (optional)
        console.error("Error fetching data:", error);
      }
    }

    if (!formStepParam) {
      currentParams.set("formStep", "2");
      navigate({
        pathname: location.pathname,
        search: currentParams.toString(),
      });
    } else if (!isNaN(Number(formStepParam))) {
      const stepFromQuery = parseInt(formStepParam, 10);
      setStep(stepFromQuery);
      setStepProgress(stepProgressLevel(stepFromQuery));
    } else if (formStepParam && formStepParam === "2" && bookingParam) {
      currentParams.set("formStep", "1");
      navigate({
        pathname: location.pathname,
        search: currentParams.toString(),
      });
    }
  };

  useEffect(() => {
    fetchCurrentPageParams();
    if (step === 1) {
      Mixpanel.track("Repair Assessment Viewed", {
        step,
        repairChoiceQuestion,
        assessmentOptions: assessmentOptions.length,
      });
    }
  }, [location.search, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const estimateResponse: any =
          await ibsAdonisService.getJobEstimateDetailsById(params.id as string);
        if (estimateResponse) {
          const findRepairChoiceOption = assessmentOptions?.find(
            ({ value }) => value === estimateResponse?.workType
          );
          if (findRepairChoiceOption) {
            setselectedAssessment(findRepairChoiceOption?.label);
          }
          setEstimate(estimateResponse);
          fetchCompassReference(estimateResponse.estimateId);
          const isOnBoardingFlow = estimateResponse.adminCheckList.some(
            (checklistItem: string) =>
              checklistItem.includes(AdminChecklistItems.ONBOARDING_FLOW)
          );
          if (!isOnBoardingFlow) {
            commonMethodService.setQueryParams(
              estimateResponse.estimateNumber,
              "home"
            );
            navigate("/");
            return;
          } else {
            setHasArrivalDates(false);
          }
          setEstimateId(estimateResponse?.estimateId);
          const qaResponse = await ibsAdonisService.getCustomQADetails(
            estimateResponse?.estimateId as string
          );
          if (qaResponse && qaResponse.length > 0) {
            const assessmentValues = (
              qaResponse[0].values.find(
                (val) => val.id === AssessmentId
              ) as IValues
            ).value as string[];

            let tempState: IQuestionResponse[] = [];
            const tempQuestionsArray = [...availableQuestionsArray];
            const index = tempQuestionsArray.findIndex(
              (question) => question.type === IQuestionType.FAULT
            );
            if (estimateResponse?.claimLiability) {
              if (estimateResponse?.claimLiability === "AtFault") {
                tempQuestionsArray[index].state = 3;
                tempQuestionsArray[index].actionState = IButtonState.YES;
                tempState.push({
                  actionState: IButtonState.YES,
                  type: IQuestionType.FAULT,
                  key: "claimLiability",
                  value: "AtFault",
                  state: 3,
                });
              } else {
                tempQuestionsArray[index].state = 3;
                tempQuestionsArray[index].actionState = IButtonState.NO;
                tempState.push({
                  actionState: IButtonState.NO,
                  type: IQuestionType.FAULT,
                  key: "claimLiability",
                  value: "NotAtFault",
                  state: 3,
                });
              }
            }
            if (assessmentValues && Array.isArray(assessmentValues)) {
              assessmentValues?.forEach((value: string) => {
                tempQuestionsArray.forEach((question, i) => {
                  if (
                    question.type === IQuestionType.FAULT_DETAILS &&
                    value === "At Fault details obtained"
                  ) {
                    tempQuestionsArray[i].state = 3;
                    tempQuestionsArray[i].actionState = IButtonState.YES;
                    tempState = tempState.filter(
                      (state) => state.type !== IQuestionType.FAULT_DETAILS
                    );
                    tempState.push({
                      actionState: IButtonState.YES,
                      type: IQuestionType.FAULT_DETAILS,
                      key: "value",
                      value: "At Fault details obtained",
                      state: 3,
                    });
                  } else if (
                    question.type === IQuestionType.FAULT_INSURANCE &&
                    value === "At Fault has insurance"
                  ) {
                    tempQuestionsArray[i].state = 3;
                    tempQuestionsArray[i].actionState = IButtonState.YES;
                    tempState = tempState.filter(
                      (state) => state.type !== IQuestionType.FAULT_INSURANCE
                    );
                    tempState.push({
                      actionState: IButtonState.YES,
                      type: IQuestionType.FAULT_INSURANCE,
                      key: "value",
                      value: "At Fault has insurance",
                      state: 3,
                    });
                  } else {
                    if (
                      !tempState.some(
                        (question) =>
                          question.type === IQuestionType.FAULT_DETAILS
                      )
                    ) {
                      tempQuestionsArray[1].state = 3;
                      tempQuestionsArray[1].actionState = IButtonState.NO;
                      tempState.push({
                        actionState: IButtonState.NO,
                        type: IQuestionType.FAULT_DETAILS,
                        key: "value",
                        value: "",
                        state: 3,
                      });
                    }

                    if (
                      !tempState.some(
                        (question) =>
                          question.type === IQuestionType.FAULT_INSURANCE
                      )
                    ) {
                      tempQuestionsArray[2].state = 3;
                      tempQuestionsArray[2].actionState = IButtonState.NO;
                      tempState.push({
                        actionState: IButtonState.NO,
                        type: IQuestionType.FAULT_INSURANCE,
                        key: "value",
                        value: "",
                        state: 3,
                      });
                    }
                  }
                });
              });
              setAvailableQuestionsArray(tempQuestionsArray);
            }
            setQuestionsArray(tempState);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    ibsAdonisService
      .fetchInspectionData(params.id as string)
      .then((res: Appointment | null) => {
        setEstimateBooking(res);
      });
    fetchData();
  }, [params.id]);

  const fetchCompassReference = (estimateId: string) => {
    ibsAdonisService.fetchCompassReference(estimateId).then((res) => {
      if (res?.compassReference) {
        setCompassReference(String(res?.compassReference));
      }
    });
  };

  const stepProgressLevel = (currentStep: number) => {
    return (100 / 4) * currentStep;
  };

  const handleQuestionResponse = (questionObj: IQuestionResponse) => {
    if (questionObj.state === 2) {
      return;
    }
    let tempArr = questionsArray.filter(
      (question) => question.type !== questionObj.type
    );
    tempArr = [...tempArr, questionObj];
    const respondedQuestionIndex = availableQuestionsArray.findIndex(
      (question) => question.type === questionObj.type
    );
    if (respondedQuestionIndex !== -1) {
      const tempAvailableQuestionsArray = [...availableQuestionsArray];
      tempAvailableQuestionsArray[respondedQuestionIndex].state = 3;
      tempAvailableQuestionsArray[respondedQuestionIndex].actionState =
        questionObj.actionState;
      if (respondedQuestionIndex < 2 && questionsArray.length < 3) {
        tempAvailableQuestionsArray[respondedQuestionIndex + 1].state = 1;
      }
      setAvailableQuestionsArray(tempAvailableQuestionsArray);
    }
    setQuestionsArray(tempArr);
  };

  const handleNextStep = async () => {
    const newStep = step + 1;
    const currentParams = new URLSearchParams(location.search);

    if (step === 4) {
      Mixpanel.track("Upload Photo- Next Step Toggled", {
        estimateId: estimate?.estimateId,
        uploadPhotoStep: step,
      });
      navigate(`/${params.id}/assessment-status`);
      return;
    }

    if (step === 1) {
      if (questionsArray.length === 3) {
        setIsLoading(true);
        const valuesArray = [
          questionsArray.find(
            (question) => question.type === IQuestionType.FAULT_DETAILS
          )?.value,
          questionsArray.find(
            (question) => question.type === IQuestionType.FAULT_INSURANCE
          )?.value,
        ].filter(Boolean);

        const obj = {
          customFieldsId: estimate?.estimateId as string,
          claimLiability: questionsArray.find(
            (question) => question.type === IQuestionType.FAULT
          )?.value,
          values: valuesArray,
        };

        try {
          const res: any = await ibsAdonisService.updateQCAssessmentDetail(obj);
          const isCompassReferralDisabled = await apiService.getGeneralSettings(
            ReferralProviderId.COMPASS
          );
          const isCarbizReferralDisabled = await apiService.getGeneralSettings(ReferralProviderId.CARBIZ);
          const isAllDisabled = await apiService.getGeneralSettings(ReferralProviderId.DISABLED);

          const getDebtorForReferral =
          await apiService.getDebtorForCompassReferral(
            estimate?.debtorId || ""
          );
          
          if (res.success) {
            Mixpanel.track("QC Assessment Update", {
              action: "Update",
              claimLiability: obj.claimLiability,
              values: obj.values,
              step: step,
              newStep: newStep,
              stepProgress: stepProgressLevel(newStep),
            });

            let debtorForReferral = false;
            let referralType: "compass" | "carbiz" | null = null;

            if (isAllDisabled?.ok) {
              const { value }: GeneralSettingType = await isAllDisabled.json();
              if (Boolean(value)) {
                debtorForReferral = true
              } else if (getDebtorForReferral?.ok) {
                debtorForReferral =
                  !!(await getDebtorForReferral.json());
              }
            }
            if (isCarbizReferralDisabled?.ok) {
              const { value }: GeneralSettingType = await isCarbizReferralDisabled.json();
              if (Boolean(value)) {
                referralType = "carbiz";
              }
            }
            if (isCompassReferralDisabled?.ok && referralType == null) {
              const { value }: GeneralSettingType =
                await isCompassReferralDisabled.json();
              if (Boolean(value)) {
                referralType = "compass";
              }
            }

            if (
              obj.values.length === 2 &&
              obj.claimLiability === "NotAtFault" &&
              !compassReference &&
              !debtorForReferral
            ) {
              if (referralType === "carbiz") {
                setCarbizModal(true);
                return;
              }
              if (referralType === "compass") {
                setCompassModal(true);
                return;
              }
              setStep(newStep);
              setStepProgress(stepProgressLevel(newStep));
            }
            setStep(newStep);
            setStepProgress(stepProgressLevel(newStep));
          }
        } catch (error) {
          console.error("Error updating QC assessment:", error);
        } finally {
          setIsLoading(false);
        }
      }
      currentParams.set("formStep", newStep.toString());
      navigate({
        pathname: location.pathname,
        search: currentParams.toString(),
      });
      return;
    }

    setStep(newStep);
    setStepProgress(stepProgressLevel(newStep));

    currentParams.set("formStep", newStep.toString());
    navigate({
      pathname: location.pathname,
      search: currentParams.toString(),
    });
  };

  const handlePreviousStep = () => {
    const newStep = step - 1;
    setStep(newStep);
    setStepProgress(stepProgressLevel(newStep));

    const currentParams = new URLSearchParams(location.search);
    currentParams.set("formStep", newStep.toString());
    navigate({
      pathname: location.pathname,
      search: currentParams.toString(),
    });
  };

  const stepHeading = () => {
    if (step === 2) return "Repair Assessment";
    else if (step === 3) return "A few questions left";
    else return "";
  };

  const sendTeamsNotification = async (isCompass: boolean = true, referrence: string = "N/A") => {
    const htmlContent = `<strong>${isCompass ? "Compass" : "Carbiz"} Reference:</strong> 
    ${isCompass ? referrence : ""} <br>
    <strong>Estimator: </strong> @${estimate?.estimatorName}<br>
    <strong>Estimate: </strong> ${estimate?.estimateNumber || ""}<br>
    <strong>IBS:</strong> <a href="https://app.ibodyshop.com/#/Estimate/${
      estimate?.estimateId
    }/header">link</a> </p>`;
    await ibsAdonisService.sendTeamsNotification({
      message: htmlContent,
      email: estimate?.email || "",
      note: {
        message: `${isCompass ? "Compass" : "Carbiz"} reference has been created`,
        estimateId: estimate?.estimateId || "",
        title: `${isCompass ? "Compass" : "Carbiz"} Reference`,
        estimateNumber: estimate?.estimateNumber,
      },
    });
  };

  const handleAssesmentModalClick = async (action: string) => {
    const currentParams = new URLSearchParams(location.search);
    const mixpanelProperties = {
      action,
      estimateId: estimate?.estimateId,
      clientFirstName: estimate?.firstName,
      clientSurname: estimate?.lastName,
      clientEmail: estimate?.email,
      clientMobile: estimate?.mobilePhone,
      clientVehicleReg: estimate?.vehicleRegistration,
      clientVehicleMake: estimate?.vehicleMake,
      clientVehicleModel: estimate?.vehicleModel,
      step: step,
    };
    if (action === "BOOK_IN") {
      setBookingIsLoading(true);
      const payload = {
        ClientFirstName: estimate?.firstName || ("" as string),
        ClientSurname: estimate?.lastName || ("" as string),
        estimateId: estimate?.estimateId as string,
        ClientEmail: estimate?.email || "",
        ClientMobile: estimate?.mobilePhone || "",
        ClientVehicleReg: estimate?.vehicleRegistration || "",
        ClientVehicleMake: estimate?.vehicleMake || "",
        ClientVehicleModel: estimate?.vehicleModel || "",
      };
      const origin = window.location.origin;
      if (origin !== process.env.REACT_APP_PRODUCTION_ORIGIN) {
        toast({
          title: "Blocked",
          description: `Request blocked due to disallowed dev or local`,
          status: "error",
          duration: 1500,
          isClosable: true,
        });
        setBookingIsLoading(false);
        setCompassModal(false);
        return;
      }
      const res: any = await ibsAdonisService.bookInCompassReference(payload);
      if (res["success"]) {
        await sendTeamsNotification(res["compassReference"]);
        Mixpanel.track("Compass Reference - Book In", {
          ...mixpanelProperties,
          compassReference: res["compassReference"],
        });
        // setStep(3);
        // setCompassModal(false);
        setModalState(2);
      }
      setBookingIsLoading(false);
    } else if (action === "NOT_INTERESTED") {
      Mixpanel.track("Compass Reference - Not Interested", {
        ...mixpanelProperties,
        reason: "User chose not to continue",
      });
      // setModalState(3);
      currentParams.set("formStep", "2");
      setStep(2);
      setStepProgress(stepProgressLevel(2));
      setCompassModal(false);
      navigate({
        pathname: location.pathname,
        search: currentParams.toString(),
      });
    } else if (action === "CONTINUE") {
      currentParams.set("formStep", "4");
      setStep(4);
      setStepProgress(stepProgressLevel(4));
      setCompassModal(false);
      navigate({
        pathname: location.pathname,
        search: currentParams.toString(),
      });
    } else {
      setCompassModal(false);
      setStep(2);
      setModalState(1);
    }
  };

  const handleCarbizAssesmentModalClick = async (action: string, selectedOption?: SelectionItem | null) => {
    const currentParams = new URLSearchParams(location.search);
    const mixpanelProperties = {
      action,
      estimateId: estimate?.estimateId,
      clientFirstName: estimate?.firstName,
      clientSurname: estimate?.lastName,
      clientEmail: estimate?.email,
      clientMobile: estimate?.mobilePhone,
      clientVehicleReg: estimate?.vehicleRegistration,
      clientVehicleMake: estimate?.vehicleMake,
      clientVehicleModel: estimate?.vehicleModel,
      step: step,
    };
    if(action === "UPDATE_MODAL"){
      setModalState(2)
    } else if (action === "BOOK_IN" && selectedOption) {
      setBookingIsLoading(true);
      const payload = {
        ClientFirstName: estimate?.firstName || ("" as string),
        ClientSurname: estimate?.lastName || ("" as string),
        estimateId: estimate?.estimateId as string,
        ClientEmail: estimate?.email || "",
        ClientMobile: estimate?.mobilePhone || "",
        ClientPostcode: "",
        ClientVehicleReg: estimate?.vehicleRegistration || "",
        ClientVehicleMake: estimate?.vehicleMake || "",
        ClientVehicleModel: estimate?.vehicleModel || "",
        ReferralNote: selectedOption?.value,
        ThirdPartyClaimNumber: "",
        AccidentDateTime: "",
        AccidentSource: "",
      };
      const origin = window.location.origin;
      const res = await apiService.requestCarbizReferral(payload);
      const data = await res.json();
      if (data.success) {
        if (origin == process.env.REACT_APP_PRODUCTION_ORIGIN) {
          await sendTeamsNotification(false);
        }
        Mixpanel.track("Carbiz Reference - Book In", {
          ...mixpanelProperties,
        });
        setModalState(3);
      }
      setBookingIsLoading(false);
    } else if (action === "NOT_INTERESTED") {
      Mixpanel.track("Carbiz Reference - Not Interested", {
        ...mixpanelProperties,
        reason: "User chose not to continue",
      });
      currentParams.set("formStep", "2");
      setStep(2);
      setStepProgress(stepProgressLevel(2));
      setCarbizModal(false);
      navigate({
        pathname: location.pathname,
        search: currentParams.toString(),
      });
    } else if (action === "CONTINUE") {
      currentParams.set("formStep", "4");
      setStep(4);
      setStepProgress(stepProgressLevel(4));
      setCarbizModal(false);
      setModalState(1)
      navigate({
        pathname: location.pathname,
        search: currentParams.toString(),
      });
    } else {
      setCarbizModal(false);
      setStep(2);
      setModalState(1);
    }
  };

  const handleLogout = () => {
    ibodyshop.logout();
    navigate("/", { replace: true });
  };

  const selectedRepairChoice = (value: AssessmentType) => {
    setselectedAssessment(value);
  };

  const handleNext = async () => {
    setLoadBtn(true);
    const findRepairChoiceOption = assessmentOptions?.find(
      ({ label }) => label === selectedAssessment
    );
    if (findRepairChoiceOption) {
      const selectedWorkType = workTypeObject[findRepairChoiceOption?.label];
      if (estimateId) {
        ibsAdonisService
          .updateWorkType(estimateId, selectedWorkType)
          .then((workTypeResponse: any) => {
            const eventData = {
              type: "WorkType Updated",
              selectedWorkType,
            };

            if (workTypeResponse.success) {
              Mixpanel.track("WorkType Updated Success", eventData);
            } else {
              Mixpanel.track("WorkType Updated Error", eventData);
            }
          })
          .catch((error: any) => {
            console.error("🚀 ~ WorkType Update Error:", error);
          })
          .finally(() => {
            setLoadBtn(false);
            handleNextStep();
          });
      }
    }
  };

  const handleBack = () => {
    navigate(
                      `/${params.id}/welcome?estimateid=${params.id}&step=home`,
                      {
                        replace: true,
                      }
                    );
  };

  return (
    <>
      {!hasArrivalDates ? (
        <>
          {step === 1 && (
            <div className="assessment-main" >
               <div className="logout-icon">
                  <img
                    src={logout}
                    onClick={handleLogout}
                    alt="Logout button"
                  />
                </div>
                <div className="top">
                  <Progress
                    width={"50%"}
                    borderRadius={"10px"}
                    value={stepProgress}
                  />
                  <p className="step-label">STEP {step}/4</p>
                  <p className="sec-heading">{stepHeading()}</p>
                </div>
              <StepThree
                handleNext={handleNextStep}
                handleBack={() =>
                  navigate(
                    `/${params.id}/welcome?estimateid=${params.id}&step=home`,
                    {
                      replace: true,
                    }
                  )
                }
                handleQuestionResponse={handleQuestionResponse}
                availableQuestions={availableQuestionsArray}
                step={step}
                isDisabled={questionsArray.length !== 3}
                isLoading={isLoading}
              />
            </div>
          )}

          {step === 3 && (
            <div className="assessment-main">
              <div className="logout-icon">
                <img src={logout} onClick={handleLogout} alt="Logout button" />
              </div>
              <div className="top">
                <Progress
                  width={"50%"}
                  borderRadius={"10px"}
                  value={stepProgress}
                />
                <p className="step-label">STEP {step}/4</p>
                <p className="sec-heading">{stepHeading()}</p>
              </div>
              <StepTwo
                handleNext={handleNextStep}
                handleBack={handlePreviousStep}
                step={step}
                bookingDate={estimateBooking?.dueDate}
                repairType={selectedAssessment}
              />
            </div>
          )}

          {step === 2 && (
            <div className="repairTypeSelectionMainContainer">
              <div>
                <div className="logout-icon-repair-type">
                  <img
                    src={logout}
                    onClick={handleLogout}
                    alt="Logout button"
                  />
                </div>
                <div className="repairProgressBar">
                  <Progress
                    width={"25%"}
                    borderRadius={"10px"}
                    value={stepProgress}
                  />
                  <p className="step-label">STEP {step}/4</p>
                  <p className="sec-heading">{stepHeading()}</p>
                </div>
              </div>
              <div className="repairTypeCenterBox">
                <div className="repair-question-container">
                  <Text fontSize={"xl"} className={"repair-question"}>
                    {repairChoiceQuestion}
                  </Text>
                </div>
                <Grid
                  templateColumns="repeat(4, 1fr)"
                  gap={2}
                  mb={2}
                  width={"100%"}
                >
                  <GridItem
                    colSpan={12}
                    gap={2}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                  >
                    {assessmentOptions?.map(({ label }, i) => (
                      <button
                        key={i}
                        className={`${
                          selectedAssessment === label
                            ? "repairType-selection-button-dark"
                            : "repairType-selection-outlined-button"
                        }`}
                        onClick={() => {
                          selectedRepairChoice(label);
                        }}
                      >
                        {label}
                      </button>
                    ))}
                  </GridItem>
                </Grid>
              </div>
              <div className="repairTypeBtnContainer">
                <button
                  className="outlined-button repairType-btn-gap"
                  onClick={() => handlePreviousStep()}
                >
                  Back
                </button>
                <button
                  className="button-dark"
                  disabled={selectedAssessment === "" || loadBtn}
                  onClick={() => {
                    handleNext();
                  }}
                >
                  {loadBtn ? "Loading..." : "Next"}
                </button>
              </div>
            </div>
          )}

          {step == 4 && (
            <div className="assessment-main">
              <div className="logout-icon">
                <img src={logout} onClick={handleLogout} alt="Logout button" />
              </div>
              <div className="top">
                <Progress
                  width={"50%"}
                  borderRadius={"10px"}
                  value={stepProgress}
                />
                <p className="step-label">STEP {step}/4</p>
                <p className="sec-heading">{stepHeading()}</p>
              </div>
              <StepFour
                handleNext={handleNextStep}
                handleBack={handlePreviousStep}
                step={step}
              />
            </div>
          )}
        </>
      ) : (
        <LoaderCommon isLoginLoader={false} loadingText={""} />
      )}
      {step === 1 && compassModal && (
        <AssessmentDialog
          modalState={modalState}
          handleModalButtonClick={handleAssesmentModalClick}
          bookingIsLoading={bookingIsLoading}
        />
      )}
      {step === 1 && carbizModal && (
        <CarbizAssessmentDialog
          modalState={modalState}
          handleModalButtonClick={handleCarbizAssesmentModalClick}
          bookingIsLoading={bookingIsLoading}
        />
      )}
    </>
  );
};

export default Assessment;
